<template>
  <div ref="root" class="ms-wrap">
    <div class="ms-toggle" @click="toggleOpen">
      <span class="ms-toggle-label">{{ toggleLabel }}</span>
      <span class="ms-toggle-meta">
        <span v-if="selectedCount" class="ms-badge">{{ selectedCount }}</span>
        <span class="ms-arrow">▾</span>
      </span>
    </div>
    <div v-if="isOpen" class="ms-dropdown">
      <div class="ms-search-row">
        <input
          v-model="search"
          class="ms-search"
          type="text"
          placeholder="Buscar..."
        >
        <button class="ms-selall" type="button" @click.stop="selectAll">Todo</button>
        <button class="ms-selall" type="button" @click.stop="clearAll">Ninguno</button>
      </div>
      <div class="ms-list">
        <label
          v-for="item in filteredItems"
          :key="item.value"
          class="ms-item"
          :class="{ checked: isChecked(item.value) }"
        >
          <input
            :checked="isChecked(item.value)"
            type="checkbox"
            @change="toggleItem(item.value)"
          >
          <span>{{ item.label }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaFiltersMultiSelect',
  props: {
    items: {
      type: Array,
      default: function () {
        return [];
      }
    },
    value: {
      type: Array,
      default: function () {
        return [];
      }
    },
    emptyLabel: {
      type: String,
      default: 'Todo'
    },
    singularLabel: {
      type: String,
      default: 'selected'
    },
    pluralLabel: {
      type: String,
      default: 'selected'
    }
  },
  data () {
    return {
      isOpen: false,
      search: ''
    };
  },
  computed: {
    selectedCount () {
      return this.value.length;
    },
    filteredItems () {
      const term = this.search.trim().toLowerCase();
      if (!term) {
        return this.items;
      }

      return this.items.filter((item) => String(item.label).toLowerCase().indexOf(term) !== -1);
    },
    toggleLabel () {
      if (!this.selectedCount) {
        return this.emptyLabel;
      }

      if (this.selectedCount === 1) {
        const selected = this.items.find((item) => this.value.indexOf(item.value) !== -1);
        return selected ? selected.label : `1 ${this.singularLabel}`;
      }

      return `${this.selectedCount} ${this.pluralLabel}`;
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen;
    },
    handleClickOutside (event) {
      if (!this.$refs.root || this.$refs.root.contains(event.target)) {
        return;
      }

      this.isOpen = false;
    },
    isChecked (value) {
      return this.value.indexOf(value) !== -1;
    },
    toggleItem (value) {
      const values = this.value.slice();
      const index = values.indexOf(value);

      if (index === -1) {
        values.push(value);
      } else {
        values.splice(index, 1);
      }

      this.$emit('input', values);
    },
    selectAll () {
      this.$emit('input', this.filteredItems.map((item) => item.value));
    },
    clearAll () {
      this.$emit('input', []);
    }
  }
};
</script>

<style scoped>
.ms-wrap {
  position: relative;
}

.ms-toggle {
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  min-width: 170px;
  padding: 5px 10px;
}

.ms-toggle-meta {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.ms-toggle-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ms-badge {
  align-items: center;
  background: var(--accent, #E94560);
  border-radius: 999px;
  color: #fff;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  height: 16px;
  justify-content: center;
  min-width: 16px;
  padding: 0 4px;
}

.ms-arrow {
  font-size: 10px;
  opacity: 0.75;
}

.ms-dropdown {
  background: #1F2040;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  left: 0;
  min-width: 220px;
  overflow: hidden;
  position: absolute;
  top: calc(100% + 4px);
  z-index: 500;
}

.ms-search-row {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  gap: 4px;
  padding: 8px;
}

.ms-search {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  color: #fff;
  flex: 1;
  font-size: 11px;
  outline: none;
  padding: 4px 8px;
}

.ms-search::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.ms-selall {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  font-size: 10px;
  padding: 3px 7px;
}

.ms-selall:hover {
  background: var(--accent, #E94560);
  border-color: var(--accent, #E94560);
  color: #fff;
}

.ms-list {
  max-height: 220px;
  overflow-y: auto;
  padding: 4px 0;
}

.ms-list::-webkit-scrollbar {
  width: 5px;
}

.ms-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.ms-item {
  align-items: center;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  display: flex;
  font-size: 12px;
  gap: 8px;
  padding: 6px 12px;
}

.ms-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.ms-item input[type='checkbox'] {
  accent-color: var(--accent, #E94560);
  cursor: pointer;
  flex-shrink: 0;
  height: 14px;
  width: 14px;
}

.ms-item.checked {
  color: #fff;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/FiltersMultiSelect.vue